<!-- 患者档案 -->
<template>
  <div class="patient-file">
    <div ref="moveDOM" v-show="showSmall" class="patient-file-small">
      <div class="top">
        <div class="header">患者档案</div>
        <img
          :width="36"
          :height="36"
          @mousedown="e => e.stopPropagation()"
          @click="openModal"
          class="big-img"
          src="@/assets/img/PatientFile/changeBig.png"
          alt="放大"
        />
      </div>
      <div class="bottom">
        <div class="head-img" @mousedown="e => e.stopPropagation()">
          <a-image :src="info?.photo || fallImg" :fallback="fallImg" />
        </div>
        <template v-if="info.name">
          <div class="name">患者-{{ info.name }}</div>
          <div class="age">
            <span class="text" v-if="info.gender === 1">男</span>
            <span class="text" v-else-if="info.gender === 0">女</span>
            <span class="text" v-else>未知</span>
            <span>{{ info.age }} 岁</span>
          </div>
        </template>
        <div class="name" v-else>未知用户</div>
      </div>
    </div>
    <a-modal
      v-if="visible"
      @cancel="handleCancel"
      width="95%"
      :visible="visible"
      :maskClosable="false"
      style="top: 40px"
      class="modal-patientFile"
    >
      <template #title>
        <ModalTitle />
      </template>
      <a-spin class="loading-box" v-if="loading"></a-spin>
      <ModalBody v-else />
      <template #footer>
        <ModalFooter />
      </template>
    </a-modal>
  </div>
</template>
<script setup>
import fallImg from '@/assets/img/chat/head_p.png'
import { computed, watch } from 'vue'
import { useStore } from 'vuex'
import ModalTitle from './ModalTitle.vue'
import ModalFooter from './ModalFooter.vue'
import ModalBody from './ModalBody/index.vue'
import { useMoveDom } from './hooksMoveDOM'
import { useWatermark } from '@/utils/watermark'
import { useRouter } from 'vue-router'
const store = useStore()
const showSmall = computed(() => store.state.patientFile.status === 2)
const visible = computed(() => store.state.patientFile.status === 1)
const info = computed(() => store.state.patientFile.info)

const { setWatermark, clear, updateWatermark } = useWatermark()
const userInfo = computed(() => store.getters.userInfo)
const loading = computed(() => store.state.patientFile.loading)

function Watermark() {
  const { erpId, realName } = userInfo.value
  const body = document.body
  setWatermark(realName + ' ' + erpId, body)
  const str = realName + ' ' + erpId
  const { clientHeight: height, clientWidth: width } = body
  updateWatermark({ str, width, height })
}
// 关闭弹窗
const handleCancel = () => {
  store.dispatch('patientFile/close')
}
const openModal = () => {
  store.commit('patientFile/SET_STATE', 1)
}
const { moveDOM } = useMoveDom()
const router = useRouter()

const currentRoute = computed(() => router.currentRoute.value)
watch(visible, show => {
  if (show) {
    //NOTE: layout 中已经添加过水印，这里不需要重复添加
    const arr = ['/helper', '/doctor', '/patient']
    const condition = currentRoute.value && !arr.includes(currentRoute.value.path)
    if (condition) {
      Watermark()
    }
  } else {
    clear()
  }
})
</script>

<style lang="scss">
// 患者档案
.modal-patientFile {
  .ant-modal-header {
    padding: 0 24px;
    height: 56px;
    .ant-modal-title {
      height: 100%;
    }
  }
  .ant-modal-content {
    .ant-modal-body {
      padding: 0;
    }
  }
}
</style>
<style lang="scss" scoped>
.patient-file {
  .patient-file-small {
    position: absolute;
    right: 24px;
    top: 110px;
    color: white;
    border-radius: 8.8px;
    background-image: linear-gradient(-76deg, #1e3372b3 0%, #0d263eb3 100%, #0d263eb3 100%);
    border: 1px solid #95d9ff;
    cursor: move;
    width: 290px;
    padding: 4px 16px 12px 16px;
    z-index: 999;
    .top {
      border-bottom: 1px solid #6f7d92;
      padding-bottom: 4px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      .header {
        font-weight: 500;
        font-size: 14px;
        color: #c7d2e3;
      }
      .big-img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        cursor: pointer;
      }
    }
    .bottom {
      display: flex;
      align-items: center;
      .head-img {
        overflow: hidden;
        cursor: default;
        border-radius: 4px;
        width: 36px;
        height: 36px;
      }
      .name {
        margin: 0 8px 0 24px;
        max-width: calc(100% - 55px - 36px - 16px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .age {
        width: 70px;
        .text {
          margin-right: 4px;
        }
      }
    }
  }
}
.loading-box {
  width: 100%;
  text-align: center;
  margin: 100px;
}
</style>
